export default "__VITE_ASSET__BVDqHwrN__"